export enum ListItemButtonsEvent {
  buttonMore = 'click_button_more details',
  buttonEnroll = 'click_button_enroll course',
}
